import {Component, OnInit} from '@angular/core';
import {takeUntil} from 'rxjs/internal/operators/takeUntil';
import {Subject} from 'rxjs/internal/Subject';
import {DtoProductGroupVM} from '../../../Model/price-list/DtoProductGroupVM';
import {AuthService} from '../../../Shared/Services/auth.service';
import {PriceListService} from '../../../Services/price-list.service';
import {environment} from '../../../../environments/environment'
import {NgxSpinnerService} from 'ngx-spinner';
import {SharedService} from '../../../Shared/Services/shared.service';
import {Router} from '@angular/router';
import {UserType} from '../../../Shared/Enums/UserType';
import {DtoProductsVM} from '../../../Model/price-list/DtoProductsVM';
import {CustomToastrService} from "../../../Shared/Services/custom-toastr.service";
import {SectorsService} from "../../../Services/sectors.service";
import {KeyValue} from "@angular/common";

@Component({
  selector: 'app-price-list',
  templateUrl: './price-list.component.html',
  styleUrl: './price-list.component.scss'
})
export class PriceListComponent implements OnInit {
  imgPath: string = environment.ImgUrl;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  AllProductPerCategory: DtoProductGroupVM[] = [];
  OriginalProductPerCategory: DtoProductGroupVM[] = [];
  ProductsList?: DtoProductsVM[];
  selectedCategory?: DtoProductGroupVM | null = null;
  isExpanded: boolean = false;
  sectors: KeyValue<string, string>[] = [];
  sectorId: string | null = null;
  categoriesLoading: boolean = false;

  constructor(private api: PriceListService, private auth: AuthService, private spinner: NgxSpinnerService,
              private shared: SharedService, private router: Router, private toastrService: CustomToastrService, private sectorsService: SectorsService) {
  }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Agent, UserType.admin, UserType.Workshop])) {
      this.spinner.show();
      this.GetSectors();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetAllProductPerCategory() {
    this.categoriesLoading = true;
    this.api.GetAllProductPerCategory(this.sectorId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.AllProductPerCategory = res.payload;
          this.OriginalProductPerCategory = res.payload;
          this.AllProductPerCategory.map((a: DtoProductGroupVM) => {
            if (this.selectedCategory == null) {
              this.selectedCategory = a;
              this.ShowProducts(a);
            }
          });
          this.categoriesLoading = false;
          this.spinner.hide();
        },
        error: (err: any) => {
          if (err.status === 400 && err.error) {
            this.toastrService.showWarningToast(null, err.error);
          }
          this.spinner.hide();
        }
      });
  }

  GetSectors() {
    return this.sectorsService.GetUserSectors()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (sectors: any) => {
          this.sectors = sectors;
          if (this.sectors.length == 1) {
            this.sectorId = this.sectors[0].key ?? null;
            this.GetAllProductPerCategory();
          }
          this.spinner.hide();
        },
        error: (err: any) => {
          if (err.status === 400 && err.error) {
            this.toastrService.showWarningToast(null, err.error);
          }
          this.spinner.hide();
        }
      });
  }
  CalcPrice(pricePerOne?: number, discount?: number) {
    return this.shared.CalcPriceByDiscount(pricePerOne, discount);
  }

  ShowProducts(category: any) {
    this.ProductsList = category.listProduct;
    this.selectedCategory = category.categoryName;
  }

  checkSearchVal(searchVal?: any) {
    this.AllProductPerCategory = this.shared.checkSearchVal(this.AllProductPerCategory, this.OriginalProductPerCategory, searchVal, 'categoryName');
  }

  get SectorName(): string | null {
    return this.sectors.filter(s => s.key === this.sectorId)[0]?.value ?? null;
  }

  changeSector(key: string) {
    this.sectorId = key;
    this.spinner.show();
    this.GetAllProductPerCategory();
  }

  expandItems() {
    this.isExpanded = !this.isExpanded;
  }
}
